// Import SVG icons
import codeLineIcon from '../assets/code-line.svg';
import dashboardFillIcon from '../assets/dashboard-fill.svg';
import terminalBoxFillIcon from '../assets/terminal-box-fill.svg';
import nftFillIcon from '../assets/nft-fill.svg';
import textBlockIcon from '../assets/text-block.svg';
import brainAiFillIcon from '../assets/brain-ai-3-fill.svg';
import webhookFillIcon from '../assets/webhook-fill.svg';

// Services data for Quanturama
export const SERVICES = [
  {
    id: 'automation-pipelines',
    title: 'Automation Pipelines & Bots',
    description: 'CEX and DEX trading bots, AI agent architectures, workflow automation, and custom pipelines — built to run without you in the loop.',
    icon: webhookFillIcon,
    tags: ['Trading Bots', 'AI Agents', 'Automation']
  },
  {
    id: 'web3-growth',
    title: 'Web3 Ecosystem Growth',
    description: 'Growth architecture, token utility design, and community mechanics for protocols that need traction — not just a whitepaper.',
    icon: nftFillIcon,
    tags: ['Protocols', 'Token Economies', 'Community']
  },
  {
    id: 'decentralized-infra',
    title: 'Decentralized Infrastructure',
    description: 'Smart contracts, DApps, SIWE auth, and full testnet-to-mainnet deployment on Polygon, BSC, and TON.',
    icon: terminalBoxFillIcon,
    tags: ['Solidity', 'DApps', 'Smart Contracts']
  },
  {
    id: 'systems-diagnosis',
    title: 'Systems Diagnosis',
    description: 'For teams who built something real and hit a wall. Architecture audit, bottleneck mapping, and a clear path forward — from someone who builds, not just advises.',
    icon: brainAiFillIcon,
    tags: ['Architecture', 'Audit', 'Strategy']
  },
];

export const NAV_LINKS = [
  { name: 'Home', path: '/', id: 'home' },
  { name: 'Services', path: '/services', id: 'services' },
  { name: 'Portfolio', path: '/portfolio', id: 'portfolio' },
  { name: 'Contact', path: '/contact', id: 'contact' },
  { name: 'Blog', path: 'https://blog.quanturama.com', id: 'blog', external: true }
];

export const COMPANY_INFO = {
  name: 'Quanturama',
  tagline: 'Automation systems, trading bots, and Web3 infrastructure for protocols, startups, and operators.',
  description: 'Quanturama builds automation systems, trading bots, and Web3 infrastructure for protocols, startups, and operators. Project-based. Retainer. Fractional. Not a studio. Not an agency. An operator.',
  email: 'hello@quanturama.com',
};
